import React from "react";
import { Box, styled } from "@mui/material";
import type { Pathway } from "../../types";
import {
  CarouselDialog,
  CarouselCard,
  CarouselCardImage,
  CarouselCardOverlay,
  CarouselCardName,
} from "./CarouselDialog";
import { SentimentBadge } from "./SentimentBadge";
import { RecommendationChip } from "./RecommendationChip";

interface PathwayViewMoreDialogProps {
  open: boolean;
  onClose: () => void;
  pathways: Pathway[];
  onPathwayClick?: (pathwayId: string) => void;
}

const ClusterIconRow = styled(Box, {
  label: "PathwayClusterIconRow",
})(() => ({
  display: "flex",
  gap: 4,
}));

const ClusterIcon = styled("img", {
  label: "PathwayClusterIcon",
})(() => ({
  width: 32,
  height: 32,
  objectFit: "contain",
}));

const TopRightContainer = styled(Box, {
  label: "PathwayTopRight",
})(() => ({
  position: "absolute",
  top: 16,
  right: 16,
  zIndex: 2,
}));

export const PathwayViewMoreDialog = ({
  open,
  onClose,
  pathways,
  onPathwayClick,
}: PathwayViewMoreDialogProps) => (
  <CarouselDialog open={open} onClose={onClose} title="Related Pathways">
    {pathways.map((pathway) => (
      <CarouselCard
        key={pathway.id}
        onClick={() => onPathwayClick?.(pathway.id)}
      >
        {pathway.displayImage?.url && (
          <CarouselCardImage
            src={
              pathway.displayImage.sizes?.hatCard?.url ||
              pathway.displayImage.url
            }
            alt={pathway.name}
          />
        )}
        <CarouselCardOverlay>
          <CarouselCardName>{pathway.name}</CarouselCardName>
          {pathway.careerClusters && pathway.careerClusters.length > 0 && (
            <ClusterIconRow>
              {pathway.careerClusters.map((cluster) =>
                cluster.icon?.url ? (
                  <ClusterIcon
                    key={cluster.id}
                    src={cluster.icon.url}
                    alt={cluster.name}
                  />
                ) : null,
              )}
            </ClusterIconRow>
          )}
        </CarouselCardOverlay>
        {pathway.sentiment ? (
          <SentimentBadge sentiment={pathway.sentiment} />
        ) : pathway.recommendation ? (
          <TopRightContainer>
            <RecommendationChip recommendation={pathway.recommendation} />
          </TopRightContainer>
        ) : null}
      </CarouselCard>
    ))}
  </CarouselDialog>
);
